import { Stack } from '@mui/material';
import _ from 'lodash';
import { useBankCustomer } from '../../providers/CustomerBankProvider';
import { VegaUserStatus } from '../../types/user';
import VegaButton from '../common/VegaButton';
import VegaDrawerContent from '../common/VegaDrawerContent';
import VegaFormInputField from '../common/VegaFormInputField';
import VegaRadioGroup, { VegaRadioOption } from '../common/VegaRadioGroup';

interface IProps {
  onClose: () => void;
  setSelectedStatus: React.Dispatch<React.SetStateAction<string>>;
  selectedStatus: string;
}

const CustomerBankFilterForm = ({
  onClose,
  selectedStatus,
  setSelectedStatus,
}: IProps) => {
  const { getCustomerBank } = useBankCustomer();

  const onClearClick = () => {
    onClose();
    setSelectedStatus('');
    getCustomerBank({});
  };
  const onSelectClick = () => {
    getCustomerBank({ status: selectedStatus });
    onClose();
  };
  return (
    <VegaDrawerContent
      renderBottomView={() => {
        return (
          <Stack direction={'row'} spacing="1rem">
            <VegaButton
              text="Clear All"
              onClick={onClearClick}
              variant="text"
              sx={{
                color: '#1047DC',
              }}
            />
            <VegaButton
              text="Apply Filter"
              onClick={onSelectClick}
              disabled={!selectedStatus.length}
            />
          </Stack>
        );
      }}
    >
      <Stack gap={2}>
        <VegaFormInputField label={'Status'}>
          <VegaRadioGroup
            options={getStatusOption()}
            value={selectedStatus}
            onChange={e => {
              setSelectedStatus(e.target.value);
            }}
          />
        </VegaFormInputField>
      </Stack>
    </VegaDrawerContent>
  );
};

export default CustomerBankFilterForm;

const getStatusOption = () =>
  Object.values(VegaUserStatus).map(item => {
    const option: VegaRadioOption = {
      label: _.startCase(_.toLower(item)),
      value: item,
    };
    return option;
  });
